import { render, staticRenderFns } from "./CascaderArea.vue?vue&type=template&id=6ea86680&scoped=true"
import script from "./CascaderArea.vue?vue&type=script&lang=js"
export * from "./CascaderArea.vue?vue&type=script&lang=js"
import style0 from "./CascaderArea.vue?vue&type=style&index=0&id=6ea86680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea86680",
  null
  
)

export default component.exports